import Service from "../../../Services/index";

const Department = {
    namespaced: true,
    state: {
        departmentList: [],
        form:{
            id: null,
            department_name : "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_DEPARTMENT: (state, res) => {
            state.departmentList = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_DEPARTMENT_BY_ID: (state, res) => {
            state.form = res;
        },
        CLEAR_FORM_DATA : (state)=>{
            state.form = {
                id: null,
                department_name : "",
            }
        }
    },
    actions: {
        setDepartment({ commit }, page = 1) {
            return Service.Department.getDepartment(page).then(data => {
                commit("GET_DEPARTMENT", data);
            });
        },
        saveDepartment({commit},data){
            if(!data.id){
                return Service.Department.createDepartment(data).then(res=>{
                    console.log("create");
                });
            }
            else{
                return Service.Department.updateDepartment(data.id,data).then(res=>{
                    console.log("update");
                });
            }
        },
        showDepartmentByID({commit},id){
            return Service.Department.showDepartment(id).then(res=>{
                commit("GET_DEPARTMENT_BY_ID",res);
            })
        },
        delete({ commit }, id) {
            return Service.Department.deleteDepartment(id)
                .catch(err => {
                    console.error(err);
                });
        },
        getAllDepartment({commit}){
            return Service.Department.getAllDepartment();
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
    }
};

export default Department;
